import { Device, i18n } from '@goodboydigital/astro';
import { Browser } from '../utils/Browser';

export default class TermsAndConditionsText
{
    
    public element: HTMLElement;
    public defaultFontSize;
    public _resize;
    
    constructor()
    {
        const linkAnalytics = i18n.translate("termsScreen_link_analytics");
        const linkAds = i18n.translate("termsScreen_link_ads");
        const linkPrivacy = i18n.translate("termsScreen_link_privacy");
        
        const message0 = i18n.translate("termsScreen_message0");
        const message1 = i18n.translate("termsScreen_message1");
        const message2 = i18n.translate("termsScreen_message2");
        const message3 = i18n.translate("termsScreen_message3");
        const message4 = i18n.translate("termsScreen_message4");
        const message5 = i18n.translate("termsScreen_message5");
        const message6 = i18n.translate("termsScreen_message6");
        
        //"<a href='" + linkAnalytics + "'" + onClick + ">"
        //"</a>"
        // const message7 = "<b>" + "<a href='" + linkAds + "'" + onClick + ">" + i18n.translate("termsScreen_message7") + "</a>" +"</b>";
        // const message8 = "<b>" + i18n.translate("termsScreen_message8") + "</b>";
        // const message9 = "<b>" + "<a href='" + linkPrivacy + "'" + onClick + ">" + i18n.translate("termsScreen_message9") + "</a>" + "</b></font>";
        
        this.defaultFontSize = 3;
        
        this.element = document.createElement("div");
        this.element.style.position = "relative"; 
        this.element.style["-webkit-touch-callout" as any] = "none";
        this.element.style["-webkit-user-select" as any] = "none";
        this.element.style["-khtml-user-select" as any] = "none";
        this.element.style["-moz-user-select" as any] = "none";
        this.element.style["-ms-user-select" as any] = "none";
        this.element.style["user-select" as any] = "none";
        this.element.style.left = "50%";
        this.element.style.fontSize = this.defaultFontSize + "vmin";
        
        this.element.style.transform = "translate(-50%, -50%)";
        this.element.style["overflow-x" as any] = "hidden";
        this.element.style["overflow-y" as any] = "scroll";
        this.element.style.textOverflow = "ellipsis";
        this.element.style.wordBreak = "break-word";
        this.element.style.fontFamily = "Trebuchet MS";
        this.element.innerHTML = "<font color = 'white'>" + "<b>" + message0 + "<br><br>";
        this.element.innerHTML += "<font color = 'white'>" + "<b>" + message1 + "<br><br>";
        this.element.innerHTML += "<font color = 'white'>" + message2 + "<br><br>";
        this.element.innerHTML += "<font color = 'white'>" + "<b>" + "<a href='" + linkAnalytics + "'>" + message3 + "<br><br>";
        this.element.innerHTML += "<font color = 'white'>" + message4 + "<br><br>";
        this.element.innerHTML += "<font color = 'white'>" + "<b>" + "<a href='" + linkAds + "'>" + message5 + "<br><br>";
        this.element.innerHTML += "<font color = 'white'>" + "<b>" + "<a href='" + linkPrivacy + "'>" + message6;
                            
        this._resize = this.resize.bind(this);
        
        //Color links
        var links = this.element.getElementsByTagName("a");
        for(var i = 0; i < links.length; i++)
        {
            if(links[i].href)
            {
                let link = links[i].href;
                links[i].onclick = () => {
                    Browser.open(link);
                    return false;
                    
                }
                links[i].href = "";
                links[i].style.color = "#EB006F";  
            }
        } 
    }
    
    show(): void
    {
        document.body.appendChild(this.element); 
        
        this.resize();
        
        window.addEventListener("resize", this._resize);
    }
    
    hide(): void
    {
        document.body.removeChild(this.element); 
        
        window.removeEventListener("resize", this._resize);
    }
    
    resize(): void
    {
        var height = Math.min(window.innerWidth, window.innerHeight);
        
        var isLandscape = window.innerWidth >= window.innerHeight;
        var padding = Device.mobile && !isLandscape ? screen.height - window.innerHeight : 0;
        this.element.style.left = `calc(50% - ${padding * 0.25}px)`;
        
        this.element.style.top = isLandscape ? "48%" : `calc(24% + ${padding * 0.1}px)`;;
        this.element.style.width = `${height * 0.825}px`;
        this.element.style.height = `${height * 0.425}px`;
        this.element.style.fontSize = `${this.defaultFontSize * (height / 100)}px`;
        
        this.element.style["overflow-x" as any] = isLandscape ? "hidden" : "scroll";
        this.element.style["overflow-y" as any] = "scroll";
        //this.fitText();
    }
    
    onLinkClick(href: string){
        
    }
    
    fitText(): void
    {
        for(var i = 0; i<3; i++){
            if(this.element.scrollHeight > this.element.clientHeight){
            
                var style = window.getComputedStyle(this.element, null).getPropertyValue('font-size');
                var oldFontSize = parseFloat(style);
                var newFontSize = oldFontSize / (this.element.scrollHeight / this.element.clientHeight);
                this.element.style.fontSize = newFontSize + "px";
            }
        }
        
    }

}
